export interface IHttpBasicResponse<T> {
  data?: T;
  error?: { message: any };
  message?: any; // <-- The error message
  status: 'success' | 'error';
  statusText?: string;
  statusCode?: number;
}

export interface JsonApiResponse<T> {
  data?: {
    id: string;
    type: string;
    attributes: T;
    meta?: any;
  };

  status?: string;
  message?: any;

  errors?: {
    status: number;
    title: string;
    detail: any;
  };
}

export interface IHttpBasicResponseEcwid<T> {
  data?: { attributes: { items: T } };
  error?: { message: any };
  message?: any; // <-- The error message
  status: 'success' | 'error';
  statusText?: string;
  statusCode?: number;
}

export interface IHttpBasicResponseStore<T> {
  data?: { attributes: any};
  error?: { message: any };
  message?: any; // <-- The error message
  status: 'success' | 'error';
  statusText?: string;
  statusCode?: number;
}

export interface IHttpBasicResponseImageEcwid<T> {
  data?: { attributes: T };
  error?: { message: any };
  message?: any; // <-- The error message
  status: 'success' | 'error';
  statusText?: string;
  statusCode?: number;
}
